import { render } from "./topic.vue?vue&type=template&id=fd1370ea&ts=true"
import script from "./topic.vue?vue&type=script&lang=ts"
export * from "./topic.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/thelounge/thelounge/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__